import React from "react";
import "./LibraryChapter.css";

export default function LibraryChapter(props) {
  console.log(props);
  return (
    <div>
      <div className="d-flex gap-3 chapter_total_library ">
        <div className="chapterNoCOntainer">
          {/* <h2 className="chapterNo">{props.indexNo+1}</h2> */}
          <img src="/images/Chapter_XS.png" className="imageSizeChapter" alt="chapterImage" />
        </div>
        {/* <img src={props.chapterImg} alt="Chapter logo"></img> */}
        <div>
          <div className="chapterno_library">{props.chapterNo}</div>
          <div className="studyMaterial mt-1">{props.StudyMaterial}</div>
        </div>
      </div>
    </div>
  );
}
